<template>
  <div class="form" style="margin-top:80px;margin-bottom: 20px;">
      <!-- <div class="title">
          <span class="t1">志愿</span>
          <span class="t2">报考</span>
      </div> -->
       <!-- <div class="tail">Voluntary registration</div> -->
      <div class="container-fluid">
          <div class="container">
              <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form1 formItem">
                          <div class="title">
														模拟查询
                          </div>
                          <div class="content">
                              <div class="label">
                                  <div class="text">选择省份：</div>
                                  <div class="input">
									  <el-select v-model="value" placeholder="选择省份">
									      <el-option
									        v-for="item in options"
									        :key="item.value"
									        :label="item.label"
									        :value="item.value">
									      </el-option>
									    </el-select>
								  </div>
                              </div>
                              <div class="label">
                                  <div class="text">选择科类：</div>
                                  <div class="input select">
                                    <el-radio  v-model="radio" label="1">文科</el-radio>
                                    <el-radio  v-model="radio" label="2">理科</el-radio>
                                  </div>
                              </div>
                              <div class="label">
									<div class="text">输入分数：</div>
									<div class="input">
										<input type="text">
										<span class="span">请输入正确的分数</span>
									</div>
                              </div>
                              <div class="label">
                                  <div class="text">选择批次：</div>
                                  <div class="input">
									  <el-select v-model="value4" placeholder="选择批次">
									      <el-option
									        v-for="item in options4"
									        :key="item.value"
									        :label="item.label"
									        :value="item.value">
									      </el-option>
									    </el-select>
								  </div>
                              </div>
                              <div class="label">
									<div class="text">院校名称：</div>
									<div class="input">
										<input type="text">
										<span class="span">请输入正确的院校名称</span>
									</div>
                              </div>
                          </div>
                          <div class="button">查询</div>
                      </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form2 formItem">
                          <div class="title">
                            学校查询
                          </div>
                           <div class="content">
                              <div class="label">
                                  <div class="text">选择省份：</div>
                                  <div class="input">
									  <el-select v-model="value2" placeholder="选择省份">
									      <el-option
									        v-for="item in options2"
									        :key="item.value"
									        :label="item.label"
									        :value="item.value">
									      </el-option>
									    </el-select>
								  </div>
                              </div>
                              <div class="label">
                                  <div class="text">选择科类：</div>
                                  <div class="input select">
                                      <el-radio  v-model="radio2" label="1">文科</el-radio>
                                      <el-radio  v-model="radio2" label="2">理科</el-radio>
                                  </div>
                              </div>
                              <div class="label">
                                  <div class="text">输入分数：</div>
                                  <div class="input">
									  <input type="text">
									  <span class="span">请输入正确的分数</span>
									</div>
                              </div>
                              <div class="label">
                                  <div class="text">选择批次：</div>
                                  <div class="input">
									  <el-select v-model="value5" placeholder="选择批次">
									      <el-option
									        v-for="item in options5"
									        :key="item.value"
									        :label="item.label"
									        :value="item.value">
									      </el-option>
									    </el-select>
								  </div>
                              </div>
                              <div class="label">
                                  <div class="text">院校名称：</div>
                                  <div class="input">
									  <input type="text">
									  <span class="span">请输入正确的院校名称</span>
									</div>
                              </div>
                          </div>
                          <div class="button">查询</div>
                      </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                      <div class="form3 formItem">
                          <div class="title">
                            专业查询
                          </div>
                           <div class="content">
                              <div class="label">
                                  <div class="text">选择省份：</div>
                                  <div class="input">
									  <el-select v-model="value3" placeholder="选择省份">
									      <el-option
									        v-for="item in options3"
									        :key="item.value"
									        :label="item.label"
									        :value="item.value">
									      </el-option>
									    </el-select>
								  </div>
                              </div>
                              <div class="label">
                                  <div class="text">选择科类：</div>
                                  <div class="input select">
                                      <el-radio  v-model="radio3" label="1">本科</el-radio>
                                      <el-radio  v-model="radio3" label="2">专科</el-radio>
                                  </div>
                              </div>
                              <div class="label">
                                  <div class="text">输入分数：</div>
                                  <div class="input">
									  <input type="text">
									  <span class="span">请输入正确的分数</span>
									</div>
                              </div>
                              <div class="label">
                                  <div class="text">选择批次：</div>
                                  <div class="input">
									  <el-select v-model="value6" placeholder="选择批次">
									      <el-option
									        v-for="item in options6"
									        :key="item.value"
									        :label="item.label"
									        :value="item.value">
									      </el-option>
									    </el-select>
								  </div>
                              </div>
                              <div class="label">
                                  <div class="text">院校名称：</div>
                                  <div class="input">
									  <input type="text">
									  <span class="span">请输入正确的院校名称</span>
									</div>
                              </div>
                          </div>
                          <div class="button">查询</div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
	components:{
	},
	data(){
		return {
			radio:"",
			radio2:"",
			radio3:"",
			options: [
				{
				  value: '选项1',
				  label: '河北省'
				}, {
				  value: '选项2',
				  label: '河南省'
				}, {
				  value: '选项3',
				  label: '蚵仔煎'
				}, {
				  value: '选项4',
				  label: '龙须面'
				}, {
				  value: '选项5',
				  label: '北京烤鸭'
				},
			],
			value: '',
			options2: [
				{
				  value: '选项1',
				  label: '河北省'
				}, {
				  value: '选项2',
				  label: '河南省'
				}, {
				  value: '选项3',
				  label: '蚵仔煎'
				}, {
				  value: '选项4',
				  label: '龙须面'
				}, {
				  value: '选项5',
				  label: '北京烤鸭'
				},
			],
			value2: '',
			options3: [
				{
				  value: '选项1',
				  label: '河北省'
				}, {
				  value: '选项2',
				  label: '河南省'
				}, {
				  value: '选项3',
				  label: '蚵仔煎'
				}, {
				  value: '选项4',
				  label: '龙须面'
				}, {
				  value: '选项5',
				  label: '北京烤鸭'
				},
			],
			value3: '',
			// 批次
			options4: [
				{
				  value: '选项1',
				  label: '河北省'
				}, {
				  value: '选项2',
				  label: '河南省'
				}, {
				  value: '选项3',
				  label: '蚵仔煎'
				}, {
				  value: '选项4',
				  label: '龙须面'
				}, {
				  value: '选项5',
				  label: '北京烤鸭'
				},
			],
			value4: '',
			options5: [
				{
				  value: '选项1',
				  label: '河北省'
				}, {
				  value: '选项2',
				  label: '河南省'
				}, {
				  value: '选项3',
				  label: '蚵仔煎'
				}, {
				  value: '选项4',
				  label: '龙须面'
				}, {
				  value: '选项5',
				  label: '北京烤鸭'
				},
			],
			value5: '',
			options6: [
				{
				  value: '选项1',
				  label: '河北省'
				}, {
				  value: '选项2',
				  label: '河南省'
				}, {
				  value: '选项3',
				  label: '蚵仔煎'
				}, {
				  value: '选项4',
				  label: '龙须面'
				}, {
				  value: '选项5',
				  label: '北京烤鸭'
				},
			],
			value6: '',
		}
	},
	mounted() {
		
	},
	methods:{
	}
}
</script>

<style>
	.el-select{width: 100%;}
	
    .form{width: 100%;}
    .form>.title{width: 393px;height: 71px;background-image: url("../images/home/titbj.png");margin: 0px auto;background-size:100% 100% ;margin-top: 76px;font-size: 48px;font-weight: bold;text-align: center;}
    .form>.title>.t1{color: #000;}
    .form>.title>.t2{color: #E23737;}
    .form>.tail{color: #E2E2E2;font-size: 16px;text-align: center;}
    .form .formItem{padding: 0px 0px;box-sizing: border-box;box-shadow: 0px 3px 27px 0px rgba(6, 0, 1, 0.11);border-radius: 0px 20px 0px 20px;overflow: hidden;padding-bottom: 27px;margin: 15px 0px;}
    .form .formItem>.title{width: 100%;height: 84px;color: #fff;line-height: 84px;font-size: 28px;text-indent: 28px;}
    .form .form1>.title{background-image: url("../images/home/form1.png");background-size: 100% 100%;background-repeat: no-repeat;}
    .form .form2>.title{background-image: url("../images/home/form2.png");background-size: 100% 100%;background-repeat: no-repeat;}
    .form .form3>.title{background-image: url("../images/home/form3.png");background-size: 100% 100%;background-repeat: no-repeat;}
    .form .formItem>.content{width: 356px;margin: 0px auto;}
    .form .formItem>.content>.label{display: flex;text-align: center;margin: 13px 0px;align-items: center;justify-content: start;}
    .form .formItem>.content>.label>.text{width: 80px;flex-grow: 0;font-size: 16px;color: #333;}
    .form .formItem>.content>.label>.input{width: 100px;flex-grow: 1;position: relative;}
	.form .formItem>.content>.label>.input .span{position: absolute;left: 10px;top: 0; height: 100%;display: flex;align-items: center; font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #FE0216;}
    .form .formItem>.content>.label>.input>input{width: 100%;flex-grow: 1;border: 1px solid #DEE0EA;height:39px;padding: 0px 10px;box-sizing: border-box;border-radius: 5px;}
    .form .formItem>.content>.label>.select{display: flex;}
    .form .formItem>.content>.label>.select>div{margin: 0px;display: flex;align-items: center;cursor: pointer;margin: 0px 15px;}
	  .form .formItem>.content>.label>.select .input{width: 14px;height: 14px;border-radius: 7px;outline: none;border: 1px solid #DEDEDE;box-sizing: border-box;background-color: #00000000;margin-right:3px ;}
	  .form .formItem>.content>.label>.select{margin: 0px;color: #fff;}
    .form .formItem>.button{width: 356px;height: 50px;background-color: #DBDBDB;text-align: center;line-height: 50px;font-size: 20px;color: #fff;margin: 0px auto;cursor: pointer;}
	.form .formItem>.button:hover{background: #2282E4;}

	@media (min-width:	768px) {
		.form{width: 100%;}
		.form>.title{width: 393px;height: 71px;background-image: url("../images/home/titbj.png");margin: 0px auto;background-size:100% 100% ;margin-top: 76px;font-size: 48px;font-weight: bold;text-align: center;}
		.form>.title>.t1{color: #000;}
		.form>.title>.t2{color: #E23737;}
    .form>.tail{color: #E2E2E2;font-size: 16px;text-align: center;margin-bottom: 55px;}
    .form .formItem{padding: 0px 0px;box-sizing: border-box;box-shadow: 0px 3px 27px 0px rgba(6, 0, 1, 0.11);border-radius: 0px 20px 0px 20px;overflow: hidden;padding-bottom: 27px;margin: 15px 0px;}
    .form .formItem>.title{width: 100%;height: 84px;color: #fff;line-height: 84px;font-size: 28px;text-indent: 28px;}
    .form .form1>.title{background-image: url("../images/home/form1.png");background-size: 100% 100%;background-repeat: no-repeat;}
    .form .form2>.title{background-image: url("../images/home/form2.png");background-size: 100% 100%;background-repeat: no-repeat;}
    .form .form3>.title{background-image: url("../images/home/form3.png");background-size: 100% 100%;background-repeat: no-repeat;}
    .form .formItem>.content{width: 356px;margin: 0px auto;}
    .form .formItem>.content>.label{display: flex;text-align: center;margin: 13px 0px;align-items: center;justify-content: start;}
    .form .formItem>.content>.label>.text{width: 80px;flex-grow: 0;font-size: 16px;color: #333;}
    .form .formItem>.content>.label>.input{width: 100px;flex-grow: 1;}
    .form .formItem>.content>.label>.input>input{width: 100%;flex-grow: 1;border: 1px solid #DEE0EA;height:39px;padding: 0px 10px;box-sizing: border-box;border-radius: 5px;}
    .form .formItem>.content>.label>.select{display: flex;}
    .form .formItem>.content>.label>.select>div{margin: 0px;display: flex;align-items: center;cursor: pointer;margin: 0px 15px;}
	  .form .formItem>.content>.label>.select .input{width: 14px;height: 14px;border-radius: 7px;outline: none;border: 1px solid #DEDEDE;box-sizing: border-box;background-color: #00000000;margin-right:3px ;}
	  .form .formItem>.content>.label>.select{margin: 0px;color: #fff;}
    .form .formItem>.button{width: 356px;height: 50px;background-color: #DBDBDB;text-align: center;line-height: 50px;font-size: 20px;color: #fff;margin: 0px auto;cursor: pointer;}
	}

	/* 中等屏幕（桌面显示器，大于等于 992px） */
	@media (min-width: 992px) {
		.form{width: 100%;}
		.form>.title{width: 393px;height: 71px;background-image: url("../images/home/titbj.png");margin: 0px auto;background-size:100% 100% ;margin-top: 76px;font-size: 48px;font-weight: bold;text-align: center;}
		.form>.title>.t1{color: #000;}
		.form>.title>.t2{color: #E23737;}
    .form>.tail{color: #E2E2E2;font-size: 16px;text-align: center;margin-bottom: 55px;}
    .form .formItem{padding: 0px 0px;box-sizing: border-box;box-shadow: 0px 3px 27px 0px rgba(6, 0, 1, 0.11);border-radius: 0px 20px 0px 20px;overflow: hidden;padding-bottom: 27px;}
    .form .formItem>.title{width: 100%;height: 84px;color: #fff;line-height: 84px;font-size: 28px;text-indent: 28px;}
    .form .form1>.title{background-image: url("../images/home/form1.png");background-size: 100% 100%;}
    .form .form2>.title{background-image: url("../images/home/form2.png");}
    .form .form3>.title{background-image: url("../images/home/form3.png");}
    .form .formItem>.content{width: 256px;margin: 0px auto;}
    .form .formItem>.content>.label{display: flex;text-align: center;margin: 13px 0px;align-items: center;justify-content: start;}
    .form .formItem>.content>.label>.text{width: 80px;flex-grow: 0;font-size: 14px;color: #333;}
    .form .formItem>.content>.label>.input{width: 100px;flex-grow: 1;}
    .form .formItem>.content>.label>.input>input{width: 100%;flex-grow: 1;border: 1px solid #DEE0EA;height: 29px;padding: 0px 10px;box-sizing: border-box;border-radius: 5px;}
    .form .formItem>.content>.label>.select{display: flex;}
    .form .formItem>.content>.label>.select>div{margin: 0px;display: flex;align-items: center;cursor: pointer;margin: 0px 15px;}
	  .form .formItem>.content>.label>.select .input{width: 14px;height: 14px;border-radius: 7px;outline: none;border: 1px solid #DEDEDE;box-sizing: border-box;background-color: #00000000;margin-right:3px ;}
	  .form .formItem>.content>.label>.select{margin: 0px;color: #fff;}
    .form .formItem>.button{width: 206px;height: 40px;background-color: #DBDBDB;text-align: center;line-height: 40px;font-size: 20px;color: #fff;margin: 0px auto;cursor: pointer;}
	}


	@media (min-width: 1200px) {
		.form{width: 100%;}
		.form>.title{width: 393px;height: 71px;background-image: url("../images/home/titbj.png");margin: 0px auto;background-size:100% 100% ;margin-top: 76px;font-size: 48px;font-weight: bold;text-align: center;}
		.form>.title>.t1{color: #000;}
		.form>.title>.t2{color: #E23737;}
    .form>.tail{color: #E2E2E2;font-size: 16px;text-align: center;margin-bottom: 55px;}
    .form .formItem{padding: 0px 0px;box-sizing: border-box;box-shadow: 0px 3px 27px 0px rgba(6, 0, 1, 0.11);border-radius: 0px 20px 0px 20px;overflow: hidden;padding-bottom: 27px;}
    .form .formItem>.title{width: 100%;height: 84px;color: #fff;line-height: 84px;font-size: 28px;text-indent: 28px;}
    .form .form1>.title{background-image: url("../images/home/form1.png");background-size: 100% 100%;}
    .form .form2>.title{background-image: url("../images/home/form2.png");}
    .form .form3>.title{background-image: url("../images/home/form3.png");}
    .form .formItem>.content{width: 306px;margin: 0px auto;}
    .form .formItem>.content>.label{display: flex;text-align: center;margin: 13px 0px;align-items: center;justify-content: start;}
    .form .formItem>.content>.label>.text{width: 80px;flex-grow: 0;font-size: 16px;color: #333;}
    .form .formItem>.content>.label>.input{width: 100px;flex-grow: 1;}
    .form .formItem>.content>.label>.input>input{width: 100%;flex-grow: 1;border: 1px solid #DEE0EA;height: 39px;padding: 0px 10px;box-sizing: border-box;border-radius: 5px;}
    .form .formItem>.content>.label>.select{display: flex;}
    .form .formItem>.content>.label>.select>div{margin: 0px;display: flex;align-items: center;cursor: pointer;margin: 0px 15px;}
	  .form .formItem>.content>.label>.select .input{width: 14px;height: 14px;border-radius: 7px;outline: none;border: 1px solid #DEDEDE;box-sizing: border-box;background-color: #00000000;margin-right:3px ;}
	  .form .formItem>.content>.label>.select{margin: 0px;color: #fff;}
    .form .formItem>.button{width: 306px;height: 50px;background-color: #DBDBDB;text-align: center;line-height: 50px;font-size: 24px;color: #fff;margin: 0px auto;cursor: pointer;}

		
	}
</style>


// WEBPACK FOOTER //
// src/views/home/form.vue